import React, { useMemo } from 'react';
import {
  ReorderUserRuleContext,
  ReorderUserRuleContextProps,
  reorderUserRuleSlice,
} from '../context/ReorderUserRuleContext';
import { ReorderUserRule } from '../types/reorderUserRule';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface ReorderUserRuleProviderProps {
  children: React.ReactNode;
}

export default function ReorderUserRuleProvider({ children }: ReorderUserRuleProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.reorderUserRules.items);
  const loading = useAppSelector(state => state.reorderUserRules.loading);

  const { reorderUserRules, groupedReorderUserRules } = useMemo(() => {
    const reorderUserRules = new Map();
    const groupedReorderUserRules = new Map();
    for (const item of items) {
      const rule = new ReorderUserRule(item);
      reorderUserRules.set(rule.id, rule);
      const group = groupedReorderUserRules.get(rule.groupId) || [];
      groupedReorderUserRules.set(rule.groupId, [...group, rule]);
    }

    return { reorderUserRules, groupedReorderUserRules };
  }, [items]);

  const reorderUserRuleContext: ReorderUserRuleContextProps = {
    reorderUserRules,
    groupedReorderUserRules,
    reorderUserRulesLoading: loading,
    setReorderUserRules: (reorderUserRules: Map<string, ReorderUserRule>) =>
      dispatch(reorderUserRuleSlice.actions.setAll([...reorderUserRules.values()])),
  };

  return <ReorderUserRuleContext.Provider value={reorderUserRuleContext}>{children}</ReorderUserRuleContext.Provider>;
}
